export const ADD_LETTER = 'ADD_LETTER';
export const SEND_WORD = 'SEND_WORD';
export const SET_ERROR = 'SET_ERROR';
export const CHANGE_THEME = 'CHANGE_THEME';
export const FINISH_GAME = 'FINISH_GAME';
export const CLEAN_WORDS = 'CLEAN_WORDS';
export const ADD_LETTER_COLOR = 'ADD_LETTER_COLOR';
export const OPEN_STATS = 'OPEN_STATS';
